import React, { forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'whatsapp';
  size?: 'sm' | 'md' | 'lg';
  asChild?: boolean;
}
export const Button = forwardRef<HTMLButtonElement, ButtonProps>(({
  className,
  variant = 'primary',
  size = 'md',
  children,
  ...props
}, ref) => {
  const baseStyles = 'inline-flex items-center justify-center font-semibold rounded-full transition-all duration-200 ease-out transform-gpu hover:-translate-y-0.5 active:translate-y-0 active:scale-95 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none';
  const variants = {
    primary: 'bg-brand-600 text-white shadow-md hover:bg-brand-700 hover:shadow-xl hover:shadow-brand-500/40 focus:ring-brand-500',
    secondary: 'bg-navy-900 text-white shadow-md hover:bg-navy-800 hover:shadow-xl hover:shadow-navy-900/40 focus:ring-navy-900',
    outline: 'border-2 border-slate-200 text-slate-700 hover:border-brand-300 hover:bg-brand-50 hover:text-brand-700 focus:ring-slate-200',
    whatsapp: 'bg-[#25D366] text-white shadow-md hover:bg-[#20bd5a] hover:shadow-xl hover:shadow-[#25D366]/40 focus:ring-[#25D366]'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg'
  };
  return <button ref={ref} className={twMerge(baseStyles, variants[variant], sizes[size], className)} {...props} data-id="element-253">
        {children}
      </button>;
});
Button.displayName = 'Button';